import AdvisoryActivityCard from './component.jsx'
export default AdvisoryActivityCard
